import { useStoreState } from 'onyx-common/store'

export default useStoreState
